import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Icon from '../../core/Icon';
import Sticky from 'react-sticky-el';
import Typography from '@material-ui/core/Typography';
var STICKY_OFFSET = 0;
/**
 * @extends {React.Component<import('./types').CollapsibleGroupHeaderProps  & import('@material-ui/core').WithStyles<typeof styles, true>> }
 */

var CollapsibleGroupHeader =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CollapsibleGroupHeader, _React$Component);

  function CollapsibleGroupHeader() {
    _classCallCheck(this, CollapsibleGroupHeader);

    return _possibleConstructorReturn(this, _getPrototypeOf(CollapsibleGroupHeader).apply(this, arguments));
  }

  _createClass(CollapsibleGroupHeader, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          caption = _this$props.caption,
          open = _this$props.open,
          elevation = _this$props.elevation,
          classParentString = _this$props.classParentString,
          classes = _this$props.classes,
          showArrow = _this$props.showArrow;
      var headerStyles = {};

      if (elevation) {
        // headerStyles.boxShadow = theme.shadows[elevation];
        headerStyles.zIndex = elevation;
      }

      var headerClasses = classes.header;
      if (showArrow) headerClasses += ' ' + classes.headerWithIcon;
      var iconClasses = classes.icon;

      if (!elevation) {
        headerClasses += ' ' + classes.header2;
        iconClasses += ' ' + classes.icon2;
      }

      if (open) headerClasses += ' ' + classes.headerOpen;
      return React.createElement(Sticky, {
        disabled: elevation === 0,
        style: {
          zIndex: elevation ? 10 : 0
        },
        scrollElement: ".sidebar",
        topOffset: -STICKY_OFFSET,
        stickyClassName: classes.stickyHeader,
        boundaryElement: '.' + classParentString,
        hideOnBoundaryHit: true
      }, React.createElement("div", {
        className: headerClasses,
        style: headerStyles,
        "data-testid": "collapse-header"
      }, typeof caption === 'string' ? React.createElement(Typography, {
        color: "inherit",
        variant: elevation ? 'h5' : 'h6'
      }, caption) : caption, showArrow && React.createElement("div", {
        className: iconClasses,
        style: {
          top: open ? -2 : 0
        }
      }, React.createElement(Icon, {
        type: open ? 'panel-open' : 'panel-close',
        style: {
          fontSize: open ? 20 : 16
        }
      }))));
    }
  }]);

  return CollapsibleGroupHeader;
}(React.Component);

var styles = function styles(theme) {
  return {
    header: {
      position: 'relative',
      background: theme.palette.background.default_sidebar,
      paddingBottom: 4,
      '&:hover': {},
      color: theme.palette.text.primary,
      cursor: 'pointer'
    },
    headerWithIcon: {
      paddingLeft: theme.spacing(2)
    },
    header2: {},
    icon: {
      position: 'absolute',
      left: -2,
      top: 0,
      lineHeight: '34px',
      verticalAlign: 'middle'
    },
    icon2: {
      lineHeight: '24px'
    },
    stickyHeader: {
      marginTop: STICKY_OFFSET
    }
  };
};

CollapsibleGroupHeader.defaultProps = {
  isOpen: true,
  elevation: 0
};
export default withStyles(styles, {
  withTheme: true,
  name: 'ECCollapsibleGroupHeader'
})(CollapsibleGroupHeader);